import { render, staticRenderFns } from "./EnvironmentConfigForm.vue?vue&type=template&id=56073012&scoped=true&"
import script from "./EnvironmentConfigForm.vue?vue&type=script&lang=js&"
export * from "./EnvironmentConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentConfigForm.vue?vue&type=style&index=0&id=56073012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56073012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56073012')) {
      api.createRecord('56073012', component.options)
    } else {
      api.reload('56073012', component.options)
    }
    module.hot.accept("./EnvironmentConfigForm.vue?vue&type=template&id=56073012&scoped=true&", function () {
      api.rerender('56073012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/samurai/Settings/components/EnvironmentConfigForm.vue"
export default component.exports